export default {
	asterisk: {
		color: '#db3131',
		'&$error': {
			color: '#db3131'
		},
	}
};
